<template>
  <el-dialog
    append-to-body
    width="500px"
    title="修改密码"
    :visible.sync="visible"
    :before-close="reset"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <el-form
      v-loading="loading"
      element-loading-text="加载中…"
      ref="elFormDom"
      label-width="80px"
      label-position="right"
      :model="form.data"
      :rules="form.rules"
    >
      <el-form-item prop="password" label="密码">
        <el-input
          v-model="form.data.password"
          minlength="6"
          clearable
          placeholder="请输入密码"
        ></el-input>
      </el-form-item>
      <el-form-item label="确认密码" prop="checkPass">
          <el-input v-model="form.data.checkPass" minlength="6"  placeholder="请再次输入"></el-input>
      </el-form-item>
    </el-form>
    <template #footer>
      <el-row type="flex" justify="end">
        <el-button @click="toggle(false)">取消</el-button>
        <el-button
          type="primary"
          :loading="form.loading"
          :disabled="form.loading"
          @click="confirm"
          >确定</el-button>
      </el-row>
    </template>
  </el-dialog>
</template>

<script>
  export default {
    name: 'Password',
    data() {
      var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入新密码'));
      } else {
        if (this.form.data.checkPass !== '') {
          this.$refs.elFormDom.validateField('checkPass');
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.form.data.password) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
      return {
        visible: false,
        isChange: false,
        loading: false,
        form: {
          loading: false,
          data: {
            id: '',
            password: '',
            checkPass:"",
          },
          rules: {
            password: [
            { required: true, validator: validatePass, trigger: 'blur' }
          ],
          checkPass: [
            { required: true, validator: validatePass2, trigger: 'blur' }
          ],
          }
        }
      }
    },
    methods: {
      // 获取详情
      getDetail(row) {
        this.isChange = true
        this.form.data = row
      },
      reset(done) {
        this.isChange = false
        this.form.data = {
          id: '',
          password: '',
          checkPass:"",
        }
        this.$refs.elFormDom.resetFields()
        done && done()
      },
      toggle(show) {
        this.visible = show
        !show && this.reset()
      },
      // 提交
      confirm() {
        this.$refs.elFormDom.validate(valid => {
          if (valid) {
            let {id, password ,checkPass} = this.form.data;
            this.$http.post('/agency/account/updatePassword', { id:id, password:password,checkPass }).then(res => {
              if(res.code === 1) {
                this.$message.success('操作成功！')
                this.toggle(false)
              } else {
                this.$message.error(res.msg)
              }
           }).finally(() => {
             this.form.loading = false;
           })
          }
        })
      }
    }
  }
</script>
